import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=922382e6&scoped=true&"
import script from "./BasePopup.vue?vue&type=script&lang=ts&"
export * from "./BasePopup.vue?vue&type=script&lang=ts&"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=922382e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922382e6",
  null
  
)

/* custom blocks */
import block0 from "./BasePopup.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports